import { render, staticRenderFns } from "./form-educational-institution.vue?vue&type=template&id=7b25f8b1&lang=pug&"
import script from "./form-educational-institution.vue?vue&type=script&lang=js&"
export * from "./form-educational-institution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports